<template>
  <div class="footer">
    <p>&copy; 2025 reallove.com.br All rights reserved.</p>
  </div>
</template>
<script>
export default {
  name: 'FooterComponent',
  methods: {
    goToCart() {
      this.$router.push('/cart');
    }
  }
};
</script>
<style lang="scss" scoped>

.footer {
  background-color: #333;
  color: white;
  text-align: center;
  padding: 20px 0;
  margin-top: 40px;
  width: 100%;
}

.footer p {
  margin: 0;
}

/* 漂浮购物车按钮 */
.floating-cart {
  position: fixed;
  right: 30px;
  top: 50vh;
  z-index: 1000;
  cursor: pointer;
}

.floating-cart .el-button {
  width: 60px;
  height: 60px;
  background-color: #00c950;
  color: #fff;
  border-color: #00c950;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.floating-cart .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.cart-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff4757;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  border: 2px solid white;
}

/* 购物车按钮弹跳动画 */
.cart-bounce {
  animation: cartBounce 0.6s ease-in-out;
}

@keyframes cartBounce {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(0.9);
  }
  75% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* 购物车徽章出现动画 */
.cart-badge {
  animation: badgeAppear 0.3s ease-out;
}

@keyframes badgeAppear {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
